import { Box, CircularProgress } from '@mui/material';
import { CircleMinus, Download } from 'lucide-react';
import { useState } from 'react';
import MenuItem from '~/components/Menu/MenuItem';
import SidebarActionMenu from '~/components/Menu/SidebarActionMenu';
import { Image3D } from '~/domain/patient/image3d';
import { downloadImageToDisk } from '~/utils/io/files/downloadDicom';

type ImageActionMenuProps = {
    image: Image3D;
    onUnload: () => void;
};

export default function ImageActionMenu({
    image,
    onUnload,
}: ImageActionMenuProps) {
    const [loading, setLoading] = useState(false);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const handleDownloadImage = async () => {
        setLoading(true);
        await downloadImageToDisk(image);
        setAnchorEl(null);
        setLoading(false);
    };

    return (
        <Box mr={-0.5}>
            <SidebarActionMenu anchorEl={anchorEl} setAnchorEl={setAnchorEl}>
                <MenuItem
                    label="Download"
                    onClick={handleDownloadImage}
                    icon={
                        loading ? (
                            <CircularProgress size={16} />
                        ) : (
                            <Download size={16} />
                        )
                    }
                />
                <MenuItem
                    label="Unload"
                    onClick={() => {
                        setAnchorEl(null);
                        onUnload();
                    }}
                    icon={<CircleMinus size={16} />}
                />
            </SidebarActionMenu>
        </Box>
    );
}
